import { Flex } from 'components/layout';
import { Typography } from 'components/typography';

import { HANDLED_STATE_LABELS } from '../constants';
import { HandledGroupState, QuoteRequestBatch } from '../types';
import { HandledQuoteRow } from './HandledQuoteRow';

type HandledQuoteBatchProps = {
  // Lanes to render now (the group pages long lists).
  visibleLanes: QuoteRequestBatch;
  allLanes: QuoteRequestBatch;
  state: HandledGroupState;
  ordinalOffset: number;
  selectedIds: Set<number>;
  onToggleLane: (laneId: number) => void;
  onSelectLanes: (laneIds: number[]) => void;
  showSelectAll?: boolean;
  selectionEnabled?: boolean;
};

// Handled lanes from one email. No batch header: the group header already names the state,
// and numbering runs across the group so a long batch reads as one list.
export function HandledQuoteBatch({
  visibleLanes,
  allLanes,
  state,
  ordinalOffset,
  selectedIds,
  onToggleLane,
  onSelectLanes,
  showSelectAll = true,
  selectionEnabled = true,
}: HandledQuoteBatchProps) {
  const laneIds = allLanes.map((lane) => lane.id);
  const allSelected =
    laneIds.length > 0 && laneIds.every((id) => selectedIds.has(id));

  return (
    <Flex direction='col' gap='xs' className='w-full'>
      {selectionEnabled && showSelectAll && (
        <button
          type='button'
          className='self-end cursor-pointer border-none bg-transparent px-1'
          onClick={() => onSelectLanes(laneIds)}
        >
          <Typography
            variant='body-xxs'
            className='text-[10px] font-medium text-accent-700 hover:underline'
          >
            {allSelected
              ? `Clear all ${HANDLED_STATE_LABELS[state].toLowerCase()}`
              : `Select all ${HANDLED_STATE_LABELS[state].toLowerCase()}`}
          </Typography>
        </button>
      )}
      {visibleLanes.map((lane, index) => (
        <HandledQuoteRow
          key={lane.id}
          lane={lane}
          state={state}
          ordinal={`${ordinalOffset + index + 1}.`}
          selected={selectedIds.has(lane.id)}
          selectionEnabled={selectionEnabled}
          onToggle={() => onToggleLane(lane.id)}
        />
      ))}
    </Flex>
  );
}
